import { useTranslation } from "react-i18next";
import downloadUplus from "../../assets/downloadUplus.png";
import downloadUplusRw from "../../assets/downloadUplusRW.png";
import { motion } from "framer-motion"; // Add this import
import { useAppContext } from "../../context";
import AppDownloadButtons from "../../components/downloadButtons";

export default function DownloadSection() {
  const { t } = useTranslation();
  const { language } = useAppContext();

  return (
    <div
      id="download"
      className="flex flex-col md:flex-row items-center justify-between  bg-[rgb(0,73,69)] text-white my-20 lg:rounded-3xl gap-3 bg-radial-gradient-2 container mx-auto  lg:px-8"
    >
      {/* Left Side - Text Content */}
      <motion.div
        className="flex justify-center md:w-1/2 p-4"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <div className="flex flex-col gap-2 md:gap-4">
          <h1 className="text-3xl font-bold text-white mb-4">
            {t("downloadSection.title")}
          </h1>
          <p className="text-white mb-6">{t("downloadSection.line")}</p>
          <AppDownloadButtons />
        </div>
      </motion.div>

      {/* Right Side - Image of the App */}
      <motion.div
        className="md:w-1/2 flex justify-center px-4 md:px-0"
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <img
          src={language === "en" ? downloadUplus : downloadUplusRw}
          alt="App Preview"
          className="h-auto max-w-full"
        />
      </motion.div>
    </div>
  );
}
